import React from 'react';
interface ClosedOrder {
  market: string;
  side: 'Buy' | 'Sell';
  type: string;
  price: string;
  quantity: string;
  status: 'Filled' | 'Canceled';
  dateTime: string;
  leverage: string;
  reduceOnly?: boolean;
}
const mockClosedOrders: ClosedOrder[] = [{
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Limit',
  price: '95,790.6',
  quantity: '0.00082670',
  status: 'Filled',
  dateTime: '1/15/26 11:35 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Market',
  price: '-',
  quantity: '-',
  status: 'Canceled',
  dateTime: '1/15/26 5:59 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Sell',
  type: 'Market',
  price: '91,772.5',
  quantity: '0.00115416',
  status: 'Filled',
  dateTime: '12/12/25 4:18 PM',
  leverage: '10x',
  reduceOnly: true
}, {
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Market',
  price: '93,487.8',
  quantity: '0.00115416',
  status: 'Filled',
  dateTime: '12/11/25 10:31 PM',
  leverage: '10x'
}, {
  market: 'BTC/USD',
  side: 'Buy',
  type: 'Market',
  price: '93,463.7',
  quantity: '0.00186441',
  status: 'Filled',
  dateTime: '12/11/25 10:31 PM',
  leverage: '10x',
  reduceOnly: true
}];
export function ClosedOrdersTable() {
  if (mockClosedOrders.length === 0) {
    return <div className="flex flex-col items-center justify-center h-full py-16" data-id="element-1952">
        <div className="w-12 h-12 rounded-full bg-background-elevated flex items-center justify-center mb-3" data-id="element-1953">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-text-tertiary" data-id="element-1954">
            <polyline points="9 11 12 14 22 4" data-id="element-1955" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" data-id="element-1956" />
          </svg>
        </div>
        <p className="text-sm text-text-secondary" data-id="element-1957">No closed orders.</p>
      </div>;
  }
  return <div className="h-full overflow-auto" data-id="element-1958">
      <table className="w-full min-w-[800px]" data-id="element-1959">
        <thead className="sticky top-0 z-10" data-id="element-1960">
          <tr className="border-b border-border-subtle" data-id="element-1961">
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1962">
              Market
            </th>
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1963">
              Side
            </th>
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1964">
              Type
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1965">
              Price
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1966">
              Quantity
            </th>
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1967">
              Status
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider" data-id="element-1968">
              Date & Time
            </th>
          </tr>
        </thead>
        <tbody data-id="element-1969">
          {mockClosedOrders.map((order, idx) => <tr key={idx} className="border-b border-border-subtle hover:bg-background-elevated transition-colors" data-id="element-1970">
              <td className="px-3 py-2" data-id="element-1971">
                <div className="flex items-center gap-2" data-id="element-1972">
                  <img src="https://cryptologos.cc/logos/bitcoin-btc-logo.svg" alt="BTC" className="w-5 h-5" data-id="element-1973" />
                  <span className="text-xs text-text-primary font-medium" data-id="element-1974">
                    {order.market}
                  </span>
                  <span className="text-[10px] text-text-tertiary bg-background-elevated px-1 py-0.5 rounded" data-id="element-1975">
                    {order.leverage}
                  </span>
                </div>
              </td>
              <td className="px-3 py-2" data-id="element-1976">
                <div className="flex items-center gap-1.5" data-id="element-1977">
                  <span className={`text-xs font-medium ${order.side === 'Buy' ? 'text-success' : 'text-danger'}`} data-id="element-1978">
                    {order.side}
                  </span>
                  {order.reduceOnly && <span className="text-[10px] text-text-tertiary" data-id="element-1979">
                      (Reduce)
                    </span>}
                </div>
              </td>
              <td className="px-3 py-2" data-id="element-1980">
                <span className="text-xs text-text-primary" data-id="element-1981">{order.type}</span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-1982">
                {order.price !== '-' ? <span className="font-mono text-xs text-text-primary" data-id="element-1983">
                    {order.price}
                  </span> : <span className="text-xs text-text-tertiary" data-id="element-1984">-</span>}
              </td>
              <td className="px-3 py-2 text-right" data-id="element-1985">
                {order.quantity !== '-' ? <span className="font-mono text-xs text-text-primary" data-id="element-1986">
                    {order.quantity}
                  </span> : <span className="text-xs text-text-tertiary" data-id="element-1987">-</span>}
              </td>
              <td className="px-3 py-2" data-id="element-1988">
                <span className={`text-xs font-medium ${order.status === 'Filled' ? 'text-success' : 'text-danger'}`} data-id="element-1989">
                  {order.status}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-1990">
                <span className="text-xs text-text-secondary" data-id="element-1991">
                  {order.dateTime}
                </span>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}